module.exports = __webpack_public_path__ + "img/lcp_logo.e5154aaf.png";